import type { ArgoCDGatewayHealthStatus } from "@octopusdeploy/octopus-server-client";
import { exhaustiveCheck } from "@octopusdeploy/type-utils";
import React from "react";
import { HealthyMachineIcon } from "~/areas/infrastructure/components/MachineHealthStatusIcons/HealthyMachineIcon";
import type { IconSize } from "~/areas/infrastructure/components/MachineHealthStatusIcons/IconSize";
import { UnavailableMachineIcon } from "~/areas/infrastructure/components/MachineHealthStatusIcons/UnavailableMachineIcon";
import { UnhealthyMachineIcon } from "~/areas/infrastructure/components/MachineHealthStatusIcons/UnhealthyMachineIcon";
import { UnknownMachineIcon } from "~/areas/infrastructure/components/MachineHealthStatusIcons/UnknownMachineIcon";
type ArgoCDGatewayHealthStatusIconProps = {
    healthStatus: ArgoCDGatewayHealthStatus;
    title?: string;
    iconSize?: IconSize;
};
export const ArgoCDGatewayHealthStatusIcon = (props: ArgoCDGatewayHealthStatusIconProps) => {
    const { healthStatus, title, iconSize } = props;
    switch (healthStatus) {
        case "Healthy":
            return <HealthyMachineIcon title={title} iconSize={iconSize}/>;
        case "ArgoCDConnectionIssues":
            return <UnhealthyMachineIcon title={title} iconSize={iconSize}/>;
        case "Unavailable":
            return <UnavailableMachineIcon title={title} iconSize={iconSize}/>;
        case "Unknown":
            return <UnknownMachineIcon title={title} iconSize={iconSize}/>;
        default:
            exhaustiveCheck(healthStatus, "Unknown health status type");
    }
};
